import { render, staticRenderFns } from "./feedbackDialog.vue?vue&type=template&id=e447ebce&scoped=true&"
import script from "./feedbackDialog.vue?vue&type=script&lang=tsx&"
export * from "./feedbackDialog.vue?vue&type=script&lang=tsx&"
import style0 from "./feedbackDialog.vue?vue&type=style&index=0&id=e447ebce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e447ebce",
  null
  
)

export default component.exports